export default __webpack_public_path__ + "static/media/img04.b81a4e53.svg";